import React, { FC, useState } from 'react';
import { Button, Col, InputNumber, Row, Slider } from 'antd';
import { FilterDropdownProps } from 'antd/lib/table/interface';

type Props = {
  filterProps: FilterDropdownProps;
  minValue: number;
  maxValue: number;
};

export const SliderFilter: FC<Props> = ({ filterProps, minValue, maxValue }) => {
  const [sliderValue, setSliderValue] = useState([minValue, maxValue]);

  return (
    <div className='slider-filter-dropdown'>
      <Row>
        <Col span={24}>
          <Slider
            range
            min={minValue}
            max={maxValue}
            onChange={e => {
              setSliderValue(e as number[]);
            }}
            onAfterChange={e => {
              filterProps.setSelectedKeys([e] as any);
            }}
            value={sliderValue as any}
          />
        </Col>
      </Row>
      <Row justify={'space-between'}>
        <Col span={6}>
          <InputNumber
            min={minValue}
            max={maxValue}
            value={sliderValue[0] as number}
            onChange={e => {
              if ((e as number) > sliderValue[1]) {
                return;
              }
              const fromTo = [e as number, sliderValue[1]] as any;
              setSliderValue(fromTo as number[]);
              filterProps.setSelectedKeys([fromTo] as number[]);
            }}
          />
        </Col>
        <Col span={4}>
          <Button
            onClick={() => {
              if (filterProps.clearFilters) {
                filterProps.clearFilters();
                setSliderValue([minValue, maxValue]);
              }
            }}
          >
            Reset
          </Button>
        </Col>
        <Col span={4}>
          <Button onClick={() => filterProps.confirm()}>Apply</Button>
        </Col>
        <Col span={6}>
          <InputNumber
            min={minValue}
            max={maxValue}
            value={sliderValue[1] as number}
            onChange={e => {
              if ((e as number) < sliderValue[0]) {
                return;
              }
              const fromTo = [sliderValue[0], e as number] as any;
              setSliderValue(fromTo as number[]);
              filterProps.setSelectedKeys([fromTo] as number[]);
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default SliderFilter;
